module.exports = __webpack_public_path__ + "static/media/portflow.9b894639.jpg";